import { Grid, Stack, Typography } from '@cmg/design-system';
import { FormattedTime } from '@cmg/i18n';
import React from 'react';

import GridRowPair from '../indication-section-read-view/grid-row-pair/GridRowPair';

export type Props = Readonly<{
  submittedOn: string | null | undefined;
  firmName?: string | null;
  withoutTimestamp?: boolean;
}>;

const IndicationSectionPassedReadContent: React.FC<Props> = ({
  submittedOn,
  firmName,
  withoutTimestamp = false,
}) => {
  return (
    <Stack gap={1}>
      {!withoutTimestamp && (
        <Grid container rowGap={1}>
          <GridRowPair
            label="Submitted On:"
            value={submittedOn}
            formatter={value => <FormattedTime value={value} format="dateTime" />}
          />
        </Grid>
      )}

      <div>
        <Typography variant="h4" paddingY={1}>
          Pass
        </Typography>
        <div>{firmName ?? 'Your firm'} has submitted a pass for this offering.</div>
      </div>
    </Stack>
  );
};

export default IndicationSectionPassedReadContent;
